<template>
  <div class="page-title-box">
    <div class="row align-items-center">
      <div class="col-sm-6">
        <h4 class="page-title">Minhas Turmas</h4>
      </div>
      <div class="col-sm-6">
        <ol class="breadcrumb float-right">
          <li class="breadcrumb-item"><a href="#">Inicio</a></li>
          <li class="breadcrumb-item">Turmas</li>
          <li class="breadcrumb-item active">Minhas Turmas</li>
        </ol>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <span
          class="alert-danger message-alert"
          style="
            width: 100%;
            padding: 5px;
            border-radius: 4pt;
            font-size: 12pt;
            font-weight: bold;
          "
          v-if="error_message !== ''"
        >
          {{ error_message }}
        </span>
      </div>
    </div>
    <!-- end row -->
  </div>
  <div class="row">
    <div class="col-lg-12">
      <div class="d-flex justify-content-end">
        <div class="col-lg-3 mb-2">
          <select
            class="form-control"
            style="border-radius: 16px"
            @change="onChangeYearFindClassmate"
            v-model="assessment_year"
          >
            <option value="">Selecionar o ano</option>
            <option
              :value="y"
              v-for="(y, index) in studentEntryYear"
              :key="index"
            >
              {{ y }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="col-8 col-lg-12 col-md-12">
      <div class="col-lg-12" v-if="classmates.length > 0">
        <div class="card" v-for="(c, index) in classmates" :key="index">
          <div class="row">
            <div class="col-md-12">
              <div class="card-body mb-2">
                <h4 class="text-muted">
                  {{ c.academic_year }}&ordm; Ano {{ c.level_name }} em
                  {{ c.course_name }}
                </h4>
                <hr />
                <br />
                <ul class="list-unstyled">
                  <li class="mb-2">
                    <h4 class="">
                      <i class="mdi mdi-chair-school text-primary"></i>
                      {{ c.classmate_name }}
                    </h4>
                    <small class="text-center">
                      {{ c.entry_year }}, Semstre {{ c.semester_name }},
                      {{ c.level_name }}
                    </small>
                  </li>
                  <li class="mb-2">
                    <strong class="">{{ c.subject_name }} </strong
                    ><span class="text-white"></span>
                  </li>

                  <li class="mb-2">
                    <Button
                      type="primary"
                      class="m-1 btn-md"
                      :loadingEvaluate="loadingEvaluate"
                      @click="
                        addWeightForAssessments(
                          c.subject_id,
                          c.classmate_id,
                          c.entry_year
                        )
                      "
                    >
                      Peso das Avaliações
                    </Button>

                    <Button
                      type="seconadry"
                      class="m-1 btn-md"
                      :loadingEvaluate="loadingEvaluate"
                      @click="
                        addWeightForExames(
                          c.subject_id,
                          c.classmate_id,
                          c.entry_year
                        )
                      "
                    >
                      Peso dos exames
                    </Button>

                    <Button
                      type="success"
                      @click="evaluateStudent(c.subject_id, c.classmate_id)"
                      class="m-1 btn-md ml-2"
                    >
                      Avaliar estudante
                    </Button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12" v-if="classmateByYear.length > 0">
        <div class="card" v-for="(c, index) in classmateByYear" :key="index">
          <div class="row">
            <div class="col-md-12">
              <div class="card-body mb-2">
                <h4 class="text-muted">
                  {{ c.academic_year }}&ordm; Ano {{ c.level_name }} em
                  {{ c.course_name }}
                </h4>
                <hr />
                <br />
                <ul class="list-unstyled">
                  <li class="mb-2">
                    <h4 class="">
                      <i class="mdi mdi-chair-school text-primary"></i>
                      {{ c.classmate_name }}
                    </h4>
                    <small class="text-center"
                      >{{ c.entry_year }}, Semstre {{ c.semester_name }},
                      {{ c.level_name }}
                    </small>
                  </li>
                  <li class="mb-2">
                    <strong class="">{{ c.subject_name }} </strong
                    ><span class="text-white"></span>
                  </li>

                  <li class="mb-2" v-if="currentYear <= assessment_year">
                    <Button
                      type="primary"
                      class="btn btn-primary btn-md"
                      :loadingEvaluate="loadingEvaluate"
                      @click="
                        addWeightForAssessments(
                          c.subject_id,
                          c.classmate_id,
                          c.entry_year
                        )
                      "
                    >
                      Peso das Avaliações
                    </Button>
                    <Button
                      type="seconadry"
                      class="m-1 btn-md"
                      :loadingEvaluate="loadingEvaluate"
                      @click="
                        addWeightForExames(
                          c.subject_id,
                          c.classmate_id,
                          c.entry_year
                        )
                      "
                    >
                      Peso dos exames
                    </Button>
                    <Button
                      type="success"
                      @click="evaluateStudent(c.subject_id, c.classmate_id)"
                      class="btn btn-success btn-md ml-2"
                    >
                      Avaliar estudante
                    </Button>
                  </li>
                  <li v-else>
                    <span
                      >Ja não permite mais avaliações a turma está bloqueiado
                      por questões de segurança <i class="mdi mdi-lock"></i
                    ></span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="col-lg-12"
        v-if="classmates.length == 0 && classmateByYear.length == 0"
      >
        <div class="card">
          <div class="row">
            <div class="col-md-12">
              <div class="card-body mb-2">
                <hr />
                <ul class="list-unstyled">
                  <li class="mb-2">
                    <h4 class="text-center">
                      Não foram encotrados resultados neste momento tente fazer
                      um busca...!
                    </h4>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-show="isClose" class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Informar os pesos das avaliações</h5>
          <button
            type="button"
            @click="closeModal"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div
          class="modal-body"
          style="width: 600px; height: 350px; overflow-y: auto"
        >
          <div class="row">
            <div class="col-lg-12">
              <div class="form-group">
                <select
                  class="form-control rounded-pill"
                  @change="SelectedAssissments"
                >
                  <option value="" selected>
                    Selecione os testes que deseja realizar
                  </option>
                  <option value="MINI-TESTE">MINI-TESTE</option>
                  <option value="TESTE">TESTES</option>
                  <option value="TRABALHO-PESQUISA">TRABALHO-PESQUISA</option>
                </select>
              </div>
            </div>
          </div>
          <form>
            <div class="row">
              <div class="col-lg-12 mb-4 text-info">
                <h3 class="font-14">Horas de Contacto</h3>
              </div>

              <div
                v-if="miniTeste.length > 0"
                class="col-lg-12"
                v-for="(m, index) in miniTeste"
                :key="index"
              >
                <span
                  class="float-right"
                  style="cursor: pointer"
                  @click.prevent="removerFieldsMiniTeste(index, m.formula_id)"
                >
                  <i class="fas fa-times"></i>
                </span>
                <div class="form-group">
                  <label class="form-label">
                    {{ m.assessment_type }}
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="m.percentage"
                  />
                </div>
              </div>
              <div
                v-if="miniTeste.length > 0"
                class="d-flex justify-content-end col-lg-12"
              >
                <button
                  type="button"
                  class="btn btn-success"
                  @click.prevent="addMoreMiniTeste"
                >
                  Adicionar <i class="fas fa-plus"></i>
                </button>
              </div>
              <div
                class="col-lg-12"
                v-if="Teste.length > 0"
                v-for="(t, index) in Teste"
                :key="index"
              >
                <span
                  class="float-right"
                  style="cursor: pointer"
                  @click.prevent="removerFieldsTeste(index)"
                >
                  <i class="fas fa-times"></i>
                </span>

                <div class="form-group">
                  <label class="form-label">{{ t.assessment_type }} </label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="t.percentage"
                  />
                </div>
              </div>
              <div
                v-if="Teste.length > 0"
                class="d-flex justify-content-end col-lg-12"
              >
                <button
                  type="button"
                  class="btn btn-success"
                  @click.prevent="addMoreTeste"
                >
                  Adicionar <i class="fas fa-plus"></i>
                </button>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12 mb-4 text-info">
                <h3 class="font-14 text-danger">
                  Horas de Estudo Independente
                </h3>
              </div>

              <div
                class="col-lg-12"
                v-if="Jobs.length > 0"
                v-for="(j, index) in Jobs"
                :key="index"
              >
                <span
                  class="float-right"
                  style="cursor: pointer"
                  @click.prevent="removerFieldsJobs(index)"
                >
                  <i class="fas fa-times"></i>
                </span>
                <div class="form-group">
                  <label class="form-label"> {{ j.assessment_type }} </label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="j.percentage"
                  />
                </div>
              </div>
              <div
                v-if="Jobs.length > 0"
                class="d-flex justify-content-end col-lg-12"
              >
                <button
                  type="button"
                  class="btn btn-success"
                  @click.prevent="addMoreJobs"
                >
                  Adicionar <i class="fas fa-plus"></i>
                </button>
              </div>
            </div>
          </form>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            @click="handleSubmitWeight"
            class="btn btn-success"
          >
            Salvar
          </button>

          <button
            @click="closeModal"
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
          >
            Não
          </button>
        </div>
      </div>
    </div>
  </div>

  <div v-show="isCloseExame" class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Informar os pesos dos Exames</h5>
          <button
            type="button"
            @click="isCloseExameModal"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div
          class="modal-body"
          style="width: 600px; height: 350px; overflow-y: auto"
        >
          <form>
            <div class="row">
              <div class="col-lg-12">
                <div class="form-group">
                  <label class="form-label"> MEDIA DE FREQUENCIA </label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="mediaFrequenciaPer"
                  />
                </div>
              </div>

              <div class="col-lg-12">
                <div class="form-group">
                  <label class="form-label">EXAME NORMAL </label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="exameNormalPer"
                  />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12">
                <div class="form-group">
                  <label class="form-label">RECORRENCIA</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="recorrenciaPer"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            @click="handleSubmitWeightExames"
            class="btn btn-success"
          >
            Salvar
          </button>

          <button
            @click="isCloseExameModal"
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
          >
            Não
          </button>
        </div>
      </div>
    </div>
  </div>

  <Loading :loadingData="loading"></Loading>
</template>

<script setup>
import { onMounted, ref } from "vue";
import TeacherDashStoreModule from "@/pages/TeacherDashboard/TeacherDashStoreModule";
import { useRoute } from "vue-router";
import toastr from "toastr";
import { useStore } from "vuex";
import router from "@/router";
import Loading from "@/components/Loading.vue";
import store from "@/store";
import { toast } from "vue3-toastify";

const studentEntryYear = ref([]);
const route = useRoute();

const st = useStore();
const classmates = ref([]);
const classmateByYear = ref([]);
const isClose = ref(false);
const isCloseExame = ref(false);
var countTrabPercent = ref(1);
var countTestPercent = ref(1);
const assessment_type = ref([]);
const assessment_type_works = ref([]);
const error_message = ref("");
const subject_id = ref();
const loading = ref(false);
const loadingEvaluate = ref(false);
const currentYear = new Date().getFullYear();

const classmate_id = ref();

const valor = ref();
const assessment_year = ref(new Date().getFullYear());
const weights = ref([
  {
    assessment_type: "MINI-TESTE",
    id: "",
    percentage: null,
  },
  {
    id: "",
    assessment_type: "TESTE-1",
    percentage: null,
  },
  {
    id: "",
    assessment_type: "TESTE-2",
    percentage: null,
  },

  {
    id: "",
    assessment_type: "TRABALHO-PESQUISA-1",
    percentage: null,
  },
  {
    id: "",
    assessment_type: "TRABALHO-PESQUISA-2",
    percentage: null,
  },
  {
    id: "",
    assessment_type: "TRABALHO-PESQUISA-3",
    percentage: null,
  },
  {
    id: "",
    assessment_type: "EXAME-NORMAL",
    percentage: null,
  },

  {
    id: "",
    assessment_type: "RECORRENCIA",
    percentage: null,
  },
]);
const mediaFrequenciaPer = ref("");
const exameNormalPer = ref("");
const recorrenciaPer = ref("");
const miniTeste = ref([]);
const Teste = ref([]);
const Jobs = ref([]);
const removeTeste = ref([]);
// const extraAvaliation = ref([
//   { assessment_type: "EXAME-NORMAL", percentage: 70 },
//   { assessment_type: "RECORRENCIA", percentage: 70 },
//   // { assessment_type: "MED-FINAL", percentage: 0 },
//   // { assessment_type: "RES-FINAL", percentage: 0 },
// ]);

const assessment_home_works = ref([
  {
    id: "",
    assessment_type: "TRABALHO-PESQUISA 1",
    percentage: "0",
  },
]);

// const weightsTestes = ref({
//   minTeste: {
//     min: [
//       {
//         id: "",
//         title: "",
//         percentege: "",
//       },
//     ],
//     type: "miniTeste",
//   },
//   testes: {
//     test: [
//       {
//         id: "",
//         title: "",
//         percentege: "",
//       },
//     ],
//     type: "Teste",
//   },
//   jobs: {
//     job: [
//       {
//         id: "",
//         title: "",
//         percentege: 0,
//       },
//     ],
//     type: "jobs",
//   },
// });

function findAssessmentValue(subject_id, classmate_id) {
  // let classAssessment = {
  weights.value[0].percentage =
    store.state.weightSubject.subject_weight.filter(
      (item) =>
        item.assessment_type === "MINI-TESTE" &&
        item.classmate_id === classmate_id &&
        item.subject_id == subject_id
    )[0] == undefined
      ? null
      : parseInt(
          store.state.weightSubject.subject_weight.filter(
            (item) =>
              item.assessment_type === "MINI-TESTE" &&
              item.classmate_id === classmate_id &&
              item.subject_id == subject_id
          )[0].percentage
        );

  weights.value[1].percentage =
    store.state.weightSubject.subject_weight.filter(
      (item) =>
        item.assessment_type === "TESTE-1" &&
        item.classmate_id === classmate_id &&
        item.subject_id == subject_id
    )[0] == undefined
      ? null
      : parseInt(
          store.state.weightSubject.subject_weight.filter(
            (item) =>
              item.assessment_type === "TESTE-1" &&
              item.classmate_id === classmate_id &&
              item.subject_id == subject_id
          )[0].percentage
        );

  weights.value[2].percentage =
    store.state.weightSubject.subject_weight.filter(
      (item) =>
        item.assessment_type === "TESTE-2" &&
        item.classmate_id === classmate_id &&
        item.subject_id == subject_id
    )[0] == undefined
      ? null
      : parseInt(
          store.state.weightSubject.subject_weight.filter(
            (item) =>
              item.assessment_type === "TESTE-2" &&
              item.classmate_id === classmate_id &&
              item.subject_id == subject_id
          )[0].percentage
        );

  weights.value[3].percentage =
    store.state.weightSubject.subject_weight.filter(
      (item) =>
        item.assessment_type === "TRABALHO-PESQUISA-1" &&
        item.classmate_id === classmate_id &&
        item.subject_id == subject_id
    )[0] == undefined ||
    store.state.weightSubject.subject_weight.filter(
      (item) =>
        item.assessment_type === "TRABALHO-PESQUISA-1" &&
        item.classmate_id === classmate_id &&
        item.subject_id == subject_id
    )[0].percentage == null
      ? null
      : parseInt(
          store.state.weightSubject.subject_weight.filter(
            (item) =>
              item.assessment_type === "TRABALHO-PESQUISA-1" &&
              item.classmate_id === classmate_id &&
              item.subject_id == subject_id
          )[0].percentage
        );

  weights.value[4].percentage =
    store.state.weightSubject.subject_weight.filter(
      (item) =>
        item.assessment_type === "TRABALHO-PESQUISA-2" &&
        item.classmate_id === classmate_id &&
        item.subject_id == subject_id
    )[0] == undefined ||
    store.state.weightSubject.subject_weight.filter(
      (item) =>
        item.assessment_type === "TRABALHO-PESQUISA-2" &&
        item.classmate_id === classmate_id &&
        item.subject_id == subject_id
    )[0].percentage == null
      ? null
      : parseInt(
          store.state.weightSubject.subject_weight.filter(
            (item) =>
              item.assessment_type === "TRABALHO-PESQUISA-2" &&
              item.classmate_id === classmate_id &&
              item.subject_id == subject_id
          )[0].percentage
        );

  weights.value[5].percentage =
    store.state.weightSubject.subject_weight.filter(
      (item) =>
        item.assessment_type === "TRABALHO-PESQUISA-3" &&
        item.classmate_id === classmate_id &&
        item.subject_id == subject_id
    )[0] == undefined ||
    store.state.weightSubject.subject_weight.filter(
      (item) =>
        item.assessment_type === "TRABALHO-PESQUISA-3" &&
        item.classmate_id === classmate_id &&
        item.subject_id == subject_id
    )[0].percentage == null
      ? null
      : parseInt(
          store.state.weightSubject.subject_weight.filter(
            (item) =>
              item.assessment_type === "TRABALHO-PESQUISA-3" &&
              item.classmate_id === classmate_id &&
              item.subject_id == subject_id
          )[0].percentage
        );
}

onMounted(() => {
  getTurmas();
  teacherEntryYearTillToday();
});

async function evaluateStudent(subject_id, classmate_id) {
  try {
    loading.value = true;
    console.log(subject_id, classmate_id);

    const weights = await TeacherDashStoreModule.actions.getFormulaByClass(
      classmate_id,
      subject_id
    );

    if (weights.status === false) {
      return toast.info(weights.message, {
        autoClose: 1000,
      });
    }

    if (weights.length == 0) {
      return toast.info("Por favor adicione os pesos da disciplinas!", {
        autoClose: 1000,
      });
    }

    router.push({
      name: "assessment_studant",
      params: {
        subject_id: subject_id,
        classmate_id: classmate_id,
      },
    });
    console.log("s", weights);
  } catch (error) {
    console.log(error);
  } finally {
    loading.value = false;
  }
}

function inputPercentage(index, type) {
  assessment_type.value.push({
    id: index,
    assessment_type: type,
    percentage: valor,
  });
}

function SelectedAssissments(evt) {
  if (evt.target.value == "MINI-TESTE") {
    if (miniTeste.value.length > 0) {
      toastr.info(`o ${evt.target.value} ja existe`);
    } else {
      miniTeste.value.push({
        id: "",
        formula_id: "",
        assessment_type: evt.target.value + "-" + countTestPercent.value,
        percentage: "",
      });
    }
  } else if (evt.target.value == "TRABALHO-PESQUISA") {
    if (Jobs.value.length > 0) {
      toastr.info(`o ${evt.target.value} ja existe`);
    } else {
      Jobs.value.push({
        id: "",
        formula_id: "",
        assessment_type: evt.target.value + "-" + countJobs.value,
        percentage: "",
      });
    }
  } else {
    if (Teste.value.length > 0) {
      toastr.info(`o ${evt.target.value} ja existe`);
    } else {
      Teste.value.push({
        id: "",
        assessment_type: evt.target.value + "-" + countTest.value,
        percentage: "",
      });
    }
  }
}

async function getTurmas() {
  try {
    loading.value = true;
    const profile = JSON.parse(localStorage.getItem("myProfile"));
    const year = new Date().getFullYear();
    const classmateResponse =
      await TeacherDashStoreModule.actions.findClassmateByYear(
        year,
        profile.id
      );

    classmates.value = classmateResponse.data.classmate;
    console.log(classmateResponse.data);
  } catch (error) {
    console.log(error);
  } finally {
    loading.value = false;
  }
}

async function addWeightForAssessments(subject_idd, classmate_idd, year) {
  try {
    subject_id.value = subject_idd;
    classmate_id.value = classmate_idd;

    if (
      miniTeste.value.length === 0 ||
      Teste.value.length === 0 ||
      Jobs.value.length === 0
    ) {
      miniTeste.value = [];
      Teste.value = [];
      Jobs.value = [];

      loading.value = true;
      const resp = await TeacherDashStoreModule.actions.getFormulaById(
        classmate_idd,
        subject_idd,
        year
      );

      if (resp.data.data.length > 0) {
        let minTes = resp.data.data.filter((item) =>
          item.assessment_type.includes("MINI-TESTE")
        );

        let jo = resp.data.data.filter((item) =>
          item.assessment_type.includes("TRABALHO-PESQUISA")
        );

        let t = resp.data.data.filter(
          (item) =>
            item.assessment_type.includes("TESTE") &&
            !item.assessment_type.includes("MINI")
        );
        if (minTes.length > 0 && jo.length > 0 && t.length > 0) {
          minTes.forEach((item) => {
            miniTeste.value.push(item);
          });
          jo.forEach((item) => {
            Jobs.value.push(item);
          });
          t.forEach((item) => {
            Teste.value.push(item);
          });
          isClose.value = true;

          return;
        }

        if (minTes.length > 0) {
          minTes.forEach((item) => {
            miniTeste.value.push(item);
          });
        }
        if (jo.length > 0) {
          jo.forEach((item) => {
            Jobs.value.push(item);
          });
        }

        if (t.length > 0) {
          t.forEach((item) => {
            Teste.value.push(item);
          });
        }
      }
    }
    isClose.value = true;
  } catch (error) {
    console.log(error);
  } finally {
    loading.value = false;
  }
}

function isCloseExameModal() {
  isCloseExame.value = false;
}

async function addWeightForExames(subject_idd, classmate_idd, year) {
  try {
    subject_id.value = subject_idd;
    classmate_id.value = classmate_idd;

    if (
      mediaFrequenciaPer.value === "" ||
      exameNormalPer.value === "" ||
      recorrenciaPer.value === ""
    ) {
      loading.value = true;
      const resp = await TeacherDashStoreModule.actions.getFormulaExameById(
        classmate_idd,
        subject_idd,
        year
      );

      if (resp.data.data.length > 0) {
        resp.data.data.forEach((item) => {
          if (item.assessment_type === "MEDIAFREQUENCIA") {
            mediaFrequenciaPer.value = item.percentage;
          } else if (item.assessment_type === "EXAME-NORMAL") {
            exameNormalPer.value = item.percentage;
          } else {
            recorrenciaPer.value = item.percentage;
          }
        });
      }

      isCloseExame.value = true;
      return;
    }
    isCloseExame.value = true;
  } catch (error) {
    console.log(error);
  } finally {
    loading.value = false;
  }
}

function closeModal() {
  isClose.value = false;
}

async function handleSubmitWeight() {
  try {
    loading.value = true;

    var assessment_type = [
      ...miniTeste.value,
      ...Teste.value,
      ...Jobs.value,
      // ...extraAvaliation.value,
    ];

    console.log(assessment_type);

    const resp = await TeacherDashStoreModule.actions.submitData(
      assessment_type,
      classmate_id.value,
      subject_id.value,
      removeTeste.value
    );

    if (resp.data.status === true) {
      error_message.value = null;
      closeModal();
      toast.success(resp.data.message, {
        autoClose: 1000,
      });
    } else {
      toast.info(resp.data.message, {
        autoClose: 1000,
      });
    }
  } catch (error) {
    console.log(error);
    if (typeof error.response != "undefined") {
      Object.keys(error.response.data.errors).forEach((key) => {
        toastr.info(key, error.response.data.errors[key]);
      });
    }
  } finally {
    loading.value = false;
  }
}

async function handleSubmitWeightExames() {
  try {
    loading.value = true;
    if (mediaFrequenciaPer.value != null && mediaFrequenciaPer.value > 100) {
      toast.info(
        "O peso da media de frequência não pode estar acima de 100%!",
        {
          autoClose: 1000,
        }
      );
      return;
    }
    if (exameNormalPer.value != null && exameNormalPer.value > 100) {
      toast.info("O peso do exame normal não pode estar acima de 100%!", {
        autoClose: 1000,
      });
      return;
    }
    if (recorrenciaPer.value != null && recorrenciaPer.value > 100) {
      toast.info(
        "O peso do exame de recorrencia não  pode estar acima de 100%!",
        {
          autoClose: 1000,
        }
      );
      return;
    }
    if (mediaFrequenciaPer.value === "" || mediaFrequenciaPer.value === null) {
      toast.info("o campo da media de frequencia não pode estar vazio!", {
        autoClose: 1000,
      });
      return;
    }

    if (exameNormalPer.value === "" || exameNormalPer.value === null) {
      toast.info("o campo da do exame normal não pode estar vazio!", {
        autoClose: 1000,
      });
      return;
    }

    if (recorrenciaPer.value === "" || recorrenciaPer.value === null) {
      toast.info("o campo da recorencia não pode estar vazio!", {
        autoClose: 1000,
      });
      return;
    }
    const resp = await TeacherDashStoreModule.actions.submitDataExames(
      [
        {
          assessmentType: "MEDIAFREQUENCIA",
          percentage: mediaFrequenciaPer.value,
        },

        {
          assessmentType: "EXAME-NORMAL",
          percentage: exameNormalPer.value,
        },

        {
          assessmentType: "RECORRENCIA",
          percentage: recorrenciaPer.value,
        },
      ],
      classmate_id.value,
      subject_id.value,
      removeTeste.value
    );

    if (resp.data.status === true) {
      error_message.value = null;
      closeModal();
      toast.success(resp.data.message, {
        autoClose: 1000,
      });
    } else {
      toast.info(resp.data.message, {
        autoClose: 1000,
      });
    }
  } catch (error) {
    console.log(error);
    if (typeof error.response != "undefined") {
      Object.keys(error.response.data.errors).forEach((key) => {
        toastr.info(key, error.response.data.errors[key]);
      });
    }
  } finally {
    loading.value = false;
  }
}

async function getFormula() {
  const resp = await TeacherDashStoreModule.actions.getAllFormulas();
  classmateFormula.value = resp.data;
  console.log(resp);
}

function addMoreMiniTeste() {
  if (miniTeste.value.length > 0) {
    countTestPercent.value = miniTeste.value.length;
  }
  countTestPercent.value += 1;
  miniTeste.value.push({
    formula_id: "",
    assessment_type: "MINI-TESTE-" + countTestPercent.value,
    percentage: "",
  });
}
var countTest = ref(1);
function addMoreTeste() {
  if (Teste.value.length > 0) {
    countTest.value = Teste.value.length;
  }
  console.log(countTest.value);
  countTest.value += 1;
  Teste.value.push({
    assessment_type: "TESTE-" + countTest.value,
    percentage: "",
  });
}
var countJobs = ref(1);
function addMoreJobs() {
  if (Jobs.value.length > 0) {
    countJobs.value = Jobs.value.length;
  }
  countJobs.value += 1;
  Jobs.value.push({
    assessment_type: "TRABALHO-PESQUISA-" + countJobs.value,
    percentage: "",
  });
}

function removerFieldsMiniTeste(index, formula_id) {
  miniTeste.value.splice(index, 1);

  if (formula_id != "") {
    let findIindx = removeTeste.value.findIndex(
      (item) => item.formula_id === formula_id
    );

    if (findIindx == -1) {
      removeTeste.value.push({ id: formula_id });
    }
  }
}

function removerFieldsTeste(index) {
  Teste.value.splice(index, 1);
}

function removerFieldsJobs(index) {
  Jobs.value.splice(index, 1);
}

function remove(index) {
  //  datatTeste.value.testData.splice(index, 1);
  assessment_home_works.value.splice(index, 1);
  countTestPercent.value -= 1;
}

function addPercenteTrabalho() {
  countTrabPercent.value += 1;
  datatTeste.value.trabalho.push({ percentegemTrabalho: "" });
}

function removeTrabalho(index) {
  assessment_home_works.value.splice(index, 1);
  countTrabPercent.value -= 1;
}

// resposavel por retornar todos os anos do professor apartir do ano de entrada/alocacao
async function teacherEntryYearTillToday() {
  try {
    loading.value = true;

    const profile = JSON.parse(localStorage.getItem("myProfile"));

    const entryYearResponse =
      await TeacherDashStoreModule.actions.getFirstYearTeacherAlocated(
        profile.id
      );

    const currentYear = new Date().getFullYear();
    const entryYear = new Date(entryYearResponse.data.created_at).getFullYear();

    for (let year = currentYear; year >= entryYear; year--) {
      studentEntryYear.value.push(year);
    }
  } catch (error) {
    console.log(error);
  } finally {
    loading.value = false;
  }
}

async function onChangeYearFindClassmate(event) {
  try {
    loading.value = true;
    classmates.value = [];
    const profile = JSON.parse(localStorage.getItem("myProfile"));

    const classmateByYearResponse =
      await TeacherDashStoreModule.actions.findClassmateByYear(
        event.target.value,
        profile.id
      );
    classmateByYear.value = classmateByYearResponse.data?.classmate || [];
    console.log(classmateByYearResponse.data.classmate);
  } catch (error) {
    console.log(error);
  } finally {
    loading.value = false;
  }
}
</script>
